module.exports = __webpack_public_path__ + "static/media/NewDesignHrUpload.0ddfc476.svg";